import React from 'react';
import './Input.css';

class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggleOn: true,
      index: props.index,
    };

    // This binding is necessary to make `this` work in the callback
  }

  clearInput(evt) {
    evt.target.value = ""
  }

  updateInputValue(evt) {
    const answer = evt.target.value;
    if (answer.toLowerCase() === this.props.country.toLowerCase()){
      this.clearInput(evt)
      this.props.correctAnswerFunc()
    }
  }

  render() {
    return (
      <div>
        <div className='UserInput'>
          <div className='InputLabel'>
            <label class="block text-xs font-medium text-gray-500 text-left" for="Country"> Enter Country Name</label>
            <input onChange={evt => this.updateInputValue(evt)} class="w-80 p-3 mt-1 text-sm border-2 border-gray-300 rounded" id="country" type="country" />
          </div>
        </div>

        <div className="Controls">
          <button onClick={this.props.prevQuestionSkip} class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-300 rounded shadow">
           ⏮️ Previous
          </button>
          <button onClick={this.props.nextQuestionSkip} class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-300 rounded shadow">
            Next ⏭️
          </button>
          <button onClick={this.props.finish} class="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-300 rounded shadow">
            Give Up 🏳️
          </button>
        </div>
      </div>
    );
  }
}

export default Input;